import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAppGroupIdMessagePrioritizationCategoryCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/:app_group_id/message_prioritization/categories_data",
];
